/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceStatRow } from './AttendanceStatRow';
import {
    AttendanceStatRowFromJSON,
    AttendanceStatRowFromJSONTyped,
    AttendanceStatRowToJSON,
    AttendanceStatRowToJSONTyped,
} from './AttendanceStatRow';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WidgetDataAttendanceWidgetData
 */
export interface WidgetDataAttendanceWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataAttendanceWidgetData
     */
    $type?: WidgetDataAttendanceWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<AttendanceStatRow>}
     * @memberof WidgetDataAttendanceWidgetData
     */
    items: Array<AttendanceStatRow>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetDataAttendanceWidgetData
     */
    total: ApiUserTasksGetPageParameter;
}


/**
 * @export
 */
export const WidgetDataAttendanceWidgetDataTypeEnum = {
    Attendance: 'attendance'
} as const;
export type WidgetDataAttendanceWidgetDataTypeEnum = typeof WidgetDataAttendanceWidgetDataTypeEnum[keyof typeof WidgetDataAttendanceWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataAttendanceWidgetData interface.
 */
export function instanceOfWidgetDataAttendanceWidgetData(value: object): value is WidgetDataAttendanceWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function WidgetDataAttendanceWidgetDataFromJSON(json: any): WidgetDataAttendanceWidgetData {
    return WidgetDataAttendanceWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataAttendanceWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataAttendanceWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(AttendanceStatRowFromJSON)),
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
    };
}

export function WidgetDataAttendanceWidgetDataToJSON(json: any): WidgetDataAttendanceWidgetData {
    return WidgetDataAttendanceWidgetDataToJSONTyped(json, false);
}

export function WidgetDataAttendanceWidgetDataToJSONTyped(value?: WidgetDataAttendanceWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(AttendanceStatRowToJSON)),
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
    };
}

